var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.775694 0.766994C-0.261494 1.79547 -0.261494 5.15979 0.775694 6.16211C1.55141 6.72864 2.51015 7.00755 3.47761 6.93783C4.44507 7.00755 5.3951 6.72864 6.17953 6.16211C7.21672 5.13364 7.21672 1.76932 6.17953 0.766994C5.14234 -0.23533 1.81288 -0.270194 0.775694 0.766994Z",
    fill: "#B3B2CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.775694 8.81173C-0.261494 9.8402 -0.261494 13.2045 0.775694 14.2069C1.55141 14.7734 2.51015 15.0523 3.47761 14.9826C4.44507 15.0523 5.3951 14.7734 6.17953 14.2069C7.21672 13.1784 7.21672 9.81406 6.17953 8.81173C5.14234 7.80941 1.81288 7.77454 0.775694 8.81173Z",
    fill: "#B3B2CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5223 6.94654C12.4897 7.01627 13.4398 6.73736 14.2242 6.17083C15.2614 5.14236 15.2614 1.77803 14.2242 0.775708C13.187 -0.235332 9.83141 -0.26148 8.82908 0.775708C7.82676 1.8129 7.79189 5.1685 8.82908 6.17083C9.60479 6.73736 10.5635 7.00755 11.5223 6.94654Z",
    fill: "#B3B2CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82916 8.81173C7.79197 9.8402 7.79197 13.2045 8.82916 14.2069C9.60487 14.7734 10.5636 15.0523 11.5311 14.9826C12.4985 15.0523 13.4486 14.7734 14.233 14.2069C15.2702 13.1784 15.2702 9.81406 14.233 8.81173C13.1871 7.80941 9.85763 7.77454 8.82916 8.81173Z",
    fill: "#B3B2CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.546a60dca381c70c43c7bb2e4e052c24.svg";
export { ForwardRef as ReactComponent };